import {ComponentData, Entity} from "../../engine/tools/EntityManager";

export class CrankToInput implements ComponentData {

    crankEntity: Entity
    rotationOffset: number = 0
    crankSpeed = 0.0125;

    constructor(options?: Partial<CrankToInput>) {
        Object.assign(this, options)
    }
}